import React from "react";
import { Box, TableCell } from "@mui/material";
import DataTable from "src/components/DataTable";

export const DataTableWrapper = ({
  data,
  isScanTrackerLoading,
  columnView,
  itemPerPage,
  page,
  total,
  onPageClick,
  onItemPerPageChange,
  enableItemPerPageOption,
  additionalInfoMeta = [],
}) => (
  <DataTable
    isLoading={isScanTrackerLoading}
    rows={data || []}
    rowsPerPage={itemPerPage}
    page={page}
    total={total}
    onPageClick={onPageClick}
    handleItemPerPageChange={onItemPerPageChange}
    sx={{
      flex: 1,
      "& .MuiTableCell-root": {
        whiteSpace: "nowrap",
        padding: "12px 16px",
        fontSize: "0.875rem",
        color: "#374151",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
      "& .MuiTableHead-root": {
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: "#f8fafc",
        "& .MuiTableCell-root": {
          fontWeight: 600,
          color: "#1976d2",
          borderBottom: "2px solid #E5E7EB",
          textTransform: "uppercase",
          fontSize: "0.75rem",
          letterSpacing: "0.5px",
          padding: "16px",
        },
      },
      "& .MuiTableBody-root": {
        "& .MuiTableRow-root": {
          "&:hover": {
            backgroundColor: "#f1f5f9",
            "& .MuiTableCell-root": {
              color: "#1976d2",
            },
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#fafafa",
          },
        },
      },
    }}
    renderHeader={() => (
      <>
        {columnView.company && (
          <TableCell sx={{ minWidth: 120, py: 2 }}>Company</TableCell>
        )}
        {columnView.serialNumber && (
          <TableCell sx={{ minWidth: 120, py: 2 }}>Serial Number</TableCell>
        )}
        {columnView.scanDateTime && (
          <TableCell sx={{ minWidth: 120, py: 2 }}>Scan Date Time</TableCell>
        )}
        {columnView.branch && (
          <TableCell sx={{ minWidth: 120, py: 2 }}>Branch</TableCell>
        )}
        {columnView.product && (
          <TableCell sx={{ minWidth: 120, py: 2 }}>Product</TableCell>
        )}
        {columnView.ipAddress && (
          <TableCell sx={{ minWidth: 130, py: 2 }}>IP Address</TableCell>
        )}
        {columnView.location && (
          <TableCell sx={{ minWidth: 120, py: 2 }}>Location</TableCell>
        )}
        {columnView.googleMapLink && (
          <TableCell sx={{ minWidth: 160, py: 2 }}>Google Map Link</TableCell>
        )}
        {columnView.latitudeLongitude && (
          <>
            <TableCell sx={{ minWidth: 120, py: 2 }}>Latitude</TableCell>
            <TableCell sx={{ minWidth: 120, py: 2 }}>Longitude</TableCell>
          </>
        )}
        {columnView.os && (
          <TableCell sx={{ minWidth: 100, py: 2 }}>OS</TableCell>
        )}
        {columnView.browser && (
          <TableCell sx={{ minWidth: 120, py: 2 }}>Browser</TableCell>
        )}
        {columnView.deviceType && (
          <TableCell sx={{ minWidth: 120, py: 2 }}>Device Type</TableCell>
        )}
        {columnView.scanCount && (
          <TableCell sx={{ minWidth: 100, py: 2 }}>Scan Count</TableCell>
        )}
        {columnView.scanLimit && (
          <TableCell sx={{ minWidth: 100, py: 2 }}>Scan Limit</TableCell>
        )}
        {columnView.status && (
          <TableCell sx={{ minWidth: 100, py: 2 }}>Status</TableCell>
        )}
        {/* Additional Info Columns */}
        {additionalInfoMeta.map((meta) => (
          <TableCell key={meta.key} sx={{ minWidth: 120, py: 2 }}>
            {meta.title}
          </TableCell>
        ))}
      </>
    )}
    renderRow={(row) => (
      <>
        {columnView.company && <TableCell>{row.companyName}</TableCell>}
        {columnView.serialNumber && <TableCell>{row.serialNumber}</TableCell>}
        {columnView.scanDateTime && <TableCell>{row.scanDateTime}</TableCell>}
        {columnView.branch && <TableCell>{row.branch}</TableCell>}
        {columnView.product && (
          <TableCell>{row.productName || "Unknown Product"}</TableCell>
        )}
        {columnView.ipAddress && <TableCell>{row.ipAddress}</TableCell>}
        {columnView.status && <TableCell>{row.status}</TableCell>}
        {columnView.location && <TableCell>{row.location}</TableCell>}
        {columnView.googleMapLink && <TableCell>{row.googleMapLink}</TableCell>}
        {columnView.latitudeLongitude && (
          <>
            <TableCell>{row.latitude}</TableCell>
            <TableCell>{row.longitude}</TableCell>
          </>
        )}
        {columnView.os && <TableCell>{row.os}</TableCell>}
        {columnView.browser && <TableCell>{row.browser}</TableCell>}
        {columnView.deviceType && <TableCell>{row.deviceType}</TableCell>}
        {columnView.scanCount && <TableCell>{row.scanCount}</TableCell>}
        {columnView.scanLimit && <TableCell>{row.scanLimit}</TableCell>}
        {/* Additional Info Column Values */}
        {additionalInfoMeta.map((meta) => (
          <TableCell key={meta.key}>{row[meta.key] || ""}</TableCell>
        ))}
      </>
    )}
    enableItemPerPageOption={enableItemPerPageOption}
  />
);
